module.exports = __webpack_public_path__ + "img/highlights1.06ff61bb.png";